module.exports = __webpack_public_path__ + "img/211-Blanc Veiné FX.jpg";